module.exports = __webpack_public_path__ + "static/img/img_1.927f0602.jpg";